import { Controller as BaseController } from 'stimulus'

export class Controller extends BaseController {
  static targets = ['issue', 'suggestedIssue']

  issueSelected(ev) {
    this._syncInputSelectionState(ev.currentTarget, { with: this.suggestedIssueTargets })
  }

  suggestedIssueSelected(ev) {
    this._syncInputSelectionState(ev.currentTarget, { with: this.issueTargets })
  }

  _syncInputSelectionState(selectedInput, { with: otherInputs }) {
    const siblingInput = otherInputs.find(input => input.value === selectedInput.value)

    if (siblingInput) {
      siblingInput.checked = selectedInput.checked
    }
  }
}
